import { FilterableTablePayableImportBatches } from "../../components/TablePayableImportBatches/FilterableTablePayableImportBatches";
import { useBrowserPageTitle } from "../../../../shared/hooks/useBrowserPageTitle";

export const RouteImportPayables: React.FC = () => {
  useBrowserPageTitle("Bulk imports: Payables & deductions");

  return <FilterableTablePayableImportBatches />;
};
